<script lang="ts" setup>
  import VPreloader from '@/components/VPreloader/VPreloader.vue';
</script>

<template>
  <div>
    <VPreloader />
  </div>
</template>
